import React, { useState } from "react";
import styled from "styled-components";
import { Row, Col, Image, Button, Grid, Input } from "antd";
import { Link } from "react-router-dom";

import { Colors } from "../../../constant/theme/theme";
import useScreenWidth from "../../../hooks/useScreenWidth";

import Money_Img from "../../../assets/contact/Request-a-quote-49-68.webp";
import Money_Img1 from "../../../assets/contact/Submit-a-claim-67-60.webp";
import Money_Img2 from "../../../assets/contact/Track-shipment-61-62.webp";
import GlobeImage from "../../../assets/contact/micro-globe.6f6126b.png";

import Filter_DropDown from "../../Career/JobFilters/FilterField";

import {
  Box,
  BoxContent,
  BoxHeading,
  Boxx,
  HeroButton,
  LabelTitle,
  Wrapper,
} from "../../../common/globalStyle";

import FilterField from "../../Career/JobFilters/FilterField";
import { ArrowRightOutlined } from "@ant-design/icons";
import ContactUsForm from "./form";

const reasonitems = [
  {
    label: "Media enquiry",
    key: "0",
  },
  {
    label: "Institutional contact",
    key: "1",
  },
  {
    label: "Procurment",
    key: "2",
  },
];

const { useBreakpoint } = Grid;

const BoldSmallHeading = styled.div`
  font-size: 3rem;
  font-weight: 600;
  font-family: Nunito Sans;
  color: black;
  margin-top: 1rem;
  @media (max-width: 1278px) {
    font-size: 2rem;
  }
`;
const SmallHeading = styled.div`
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Nunito Sans;
  color: black;
  @media (max-width: 1278px) {
    font-size: 1rem;
  }
`;

const HeadText = styled.div`
  font-size: 4.1rem;
  font-weight: 300;
  color: ${Colors?.primary};
  font-family: Nunito Sans;
  text-transform: uppercase;
  @media (max-width: 1278px) {
    font-size: 3.5rem;
  }
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Card = styled.div`
  width: 90%;
  height: 8rem;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;
const CardHeading = styled.h1`
  font-size: 1rem;
  font-family: Nunito Sans;
  font-weight: 1000;
`;
const CardPara = styled.div`
  font-size: 0.8rem;
  font-weight: 500;
  color: ${Colors?.primary};
  font-family: Nunito Sans;
  padding: 0px 100px 50px 100px;
  text-transform: uppercase;
`;

const StyledButton = styled(Button)`
  border-radius: 0;
  height: 55px;
  width: 255px;
  padding: 0px 25px 0px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0px;
  background-color: ${({ defaultBgColor }) => defaultBgColor};
  color: ${({ defaultTextColor }) => defaultTextColor};
  position: relative;

  &:hover {
    background-color: #062352 !important;
    color: #fff !important;
  }
`;

const IconWrapper = styled.span`
  transition: visibility 0.1s ease-in-out;
  visibility: hidden;
`;

const StyledInput = styled(Input)`
  width: 100%;
  border-radius: 0;
  height: 55px;
  width: 255px;
  padding: 0px 25px 0px 25px;
`;

const Label = styled.p`
  color: #021d49;
  font-family: Nunito Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 2rem;
  height: 3rem;
  font-weight: 400;
  text-transform: none;
  margin: 0px 0px 3px 0px;
`;

const GetInTouch = () => {
  const screens = useBreakpoint();
  const { screenWidth } = useScreenWidth();
  const [selectedReason, setSelectedReason] = useState("-Select-");
  const [showForm, setShowForm] = useState(false);

  const handleSelectReason = (reason) => {
    console.log("selected resason ===>", reason);

    setSelectedReason(reasonitems[reason.key].label);
  };

  const handleShowForm = () => {
    console.log("im pressed", selectedReason);
    if (selectedReason) {
      setShowForm(true);
    } else {
      alert("Please select any reason first.");
    }
  };
  return (
    <>
      <Wrapper screens={screens} justify={"center"} alignItems={"center"}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HeadText
            style={{
              color: "#021d49",
              width: "100%",
              marginTop: "40px",
            }}
          >
            HOW CAN WE HELP YOU?
          </HeadText>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Row
              justify="center"
              gutter={50}
              style={{
                paddingTop: "2rem",
                display: "flex",
                alignItems: "center",
                flexDirection: screenWidth <= 768 ? "column" : "row",
              }}
            >
              <Col
                lg={12}
                md={20}
                xs={20}
                sm={20}
                style={{
                  padding: "10px",
                }}
              >
                <Row style={{ marginBottom: "1rem" }}>
                  <div
                    style={{
                      border: "1px solid gray",
                      padding: "30px 10px",
                      width: screenWidth <= 768 ? "100%" : "600px",
                      display: "flex",
                      flexDirection: screenWidth <= 425 ? "column" : "row",
                      justifyContent: screenWidth >= 425 ? "start" : "center",
                    }}
                  >
                    <div style={{ position: "relative", flex: 1 }}>
                      <p
                        style={{
                          marginTop: "-40px",
                          background: "white",
                          height: "20px",
                          width: "105px",
                          position: "absolute",
                          marginLeft: "5px",
                        }}
                      >
                        DIRECT ACCESS
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: screenWidth <= 768 ? "30px" : "10px",
                        flexDirection: screenWidth <= 425 ? "column" : "row",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      {[Money_Img, Money_Img1, Money_Img2].map(
                        (imgSrc, idx) => (
                          <div
                            key={idx}
                            style={{
                              border: "1px solid #001C4C",
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "column",
                              padding: "0px 10px",
                            }}
                          >
                            <Image
                              style={{
                                height: "30px",
                                marginTop: "-20px",
                                background: "white",
                              }}
                              preview={false}
                              src={imgSrc}
                              alt={`Image ${idx + 1} not found`}
                            />
                            <Link to={["/quote", "/contact", "/tracking"][idx]}>
                              <p
                                style={{
                                  borderBottom: "1px solid gray",
                                  marginBottom: "20px",
                                  width: screenWidth <= 425 ? "auto" : "100%",
                                  textAlign: "center",
                                  color: "#011F4F",
                                }}
                              >
                                {
                                  [
                                    "Quote & Services",
                                    "Submit a claim",
                                    "Track shipment",
                                  ][idx]
                                }
                              </p>
                            </Link>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </Row>
                <Row style={{ marginBottom: "1rem" }}>
                  <div
                    style={{
                      border: "1px solid gray",
                      padding: "30px",
                      width: "100%",
                      marginTop: "40px",
                    }}
                  >
                    <p
                      style={{
                        marginTop: "-40px",
                        background: "white",
                        width: "150px",
                      }}
                    >
                      SEND US A MESSAGE
                    </p>
                    <div
                      style={{
                        padding: screenWidth <= 768 ? "0px" : "20px",
                        display: "flex",
                        flexDirection: screenWidth <= 425 ? "column" : "row",
                        alignItems: "start",
                        justifyContent: "center",
                      }}
                    >
                      <div>
                        <Filter_DropDown
                          items={reasonitems}
                          labelTitle={"Select a reason"}
                          placeholder={selectedReason}
                          type={"dropdown"}
                          onSelect={handleSelectReason}
                        />
                      </div>
                      <div style={{ maxWidth: 255 }}>
                        <StyledButton
                          onClick={handleShowForm}
                          style={{
                            backgroundColor: "#121212",
                            color: "#fff",
                            width: "140px",
                            marginTop: "32px",
                            marginLeft: "10px",
                          }}
                        >
                          SELECT
                          <IconWrapper>
                            <ArrowRightOutlined style={{ color: "green" }} />
                          </IconWrapper>
                        </StyledButton>
                      </div>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col
                xs={20}
                lg={12}
                style={{
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    border: "1px solid gray",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: screenWidth < 768 ? "50px 20px" : "50px",
                    width: screenWidth <= 768 ? "100%" : "400px",
                  }}
                >
                  <div>
                    <p
                      style={{
                        marginTop: "-60px",
                        background: "white",
                        width: "170px",
                        marginLeft: screenWidth <= 768 ? "0px" : "-55px",
                      }}
                    >
                      FIND YOUR LOCAL OFFICE
                    </p>
                    <Image
                      src={GlobeImage}
                      preview={false}
                      alt="Image not found"
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <StyledButton
                      style={{
                        backgroundColor: "#121212",
                        color: "#fff",
                        width: "100%",
                        marginTop: "30px",
                      }}
                    >
                      SELECT ON MAP
                      <IconWrapper>
                        <ArrowRightOutlined style={{ color: "green" }} />
                      </IconWrapper>
                    </StyledButton>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Wrapper>
      {showForm && (
        <ContactUsForm setShowForm={setShowForm} showForm={showForm} />
      )}
    </>
  );
};

export default GetInTouch;
